import type { View } from '../../App';

interface HeaderProps {
  currentView: View;
  onViewChange: (view: View) => void;
}

export default function Header({ currentView, onViewChange }: HeaderProps) {
  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-ti-bg/80 border-b border-ti-border">
      <div className="max-w-7xl mx-auto px-6 h-14 flex items-center justify-between">
        {/* Left: Logo */}
        <button
          onClick={() => onViewChange('landing')}
          className="flex items-center gap-2 group cursor-pointer"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            className="text-ti-blue group-hover:text-ti-cyan transition-colors duration-300"
          >
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" strokeDasharray="3 3" />
            <circle cx="12" cy="12" r="6" stroke="currentColor" strokeWidth="1.5" strokeDasharray="2 2" />
            <circle cx="12" cy="12" r="2" fill="currentColor" />
            <line x1="12" y1="2" x2="12" y2="6" stroke="currentColor" strokeWidth="1.5" />
            <line x1="12" y1="18" x2="12" y2="22" stroke="currentColor" strokeWidth="1.5" />
            <line x1="2" y1="12" x2="6" y2="12" stroke="currentColor" strokeWidth="1.5" />
            <line x1="18" y1="12" x2="22" y2="12" stroke="currentColor" strokeWidth="1.5" />
          </svg>
          <span className="text-lg font-semibold text-ti-text group-hover:text-ti-blue transition-colors duration-300">
            TalentIntel
          </span>
        </button>

        {/* Center: Navigation tabs (hidden on landing) */}
        {currentView !== 'landing' && (
          <nav className="flex items-center bg-ti-surface rounded-full p-1 border border-ti-border">
            <button
              onClick={() => onViewChange('company')}
              className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer ${
                currentView === 'company'
                  ? 'bg-ti-blue text-white shadow-sm'
                  : 'text-ti-text-muted hover:text-ti-text'
              }`}
            >
              Company View
            </button>
            <button
              onClick={() => onViewChange('candidate')}
              className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer ${
                currentView === 'candidate'
                  ? 'bg-ti-blue text-white shadow-sm'
                  : 'text-ti-text-muted hover:text-ti-text'
              }`}
            >
              Candidate View
            </button>
          </nav>
        )}

        {/* Right: Attribution */}
        <span className="text-sm text-ti-text-dim">
          By{' '}
          <a
            href="https://tedvlango.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-ti-text-muted hover:text-ti-blue transition-colors duration-300"
          >
            Ted Lango
          </a>
        </span>
      </div>
    </header>
  );
}
